var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGrayNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.423,
    height: 11.422,
    viewBox: "0 0 11.423 11.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M7.217,1a5.711,5.711,0,1,0,5.711,5.711A5.718,5.718,0,0,0,7.217,1Zm0,.816a4.9,4.9,0,1,1-4.9,4.9A4.889,4.889,0,0,1,7.217,1.816ZM6.809,3.448v.816h.816V3.448Zm0,1.632v4.9h.816V5.08Z",
    transform: "translate(-1.506 -1)",
    fill: "#878db2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrayNew);
export default __webpack_public_path__ + "static/media/info-gray-new.0e7a1b5ef59527262f577e3a1a218505.svg";
export { ForwardRef as ReactComponent };